<template >
  <div class="msstatus global__scrollbar">
    <div class="" v-if="detail">
      <div class="msstatus__tracking">
        <p class="msstatus__tracking--title mb-3">SHIPMENT TRACKING STATUS</p>
        <div class="row justify-content-center msstatus__tracking--icon" v-if="isLoadingOtif">
          <b-spinner variant="secondary"></b-spinner>
        </div>
        <div v-else>
          <div class="row m-0 msstatus__tracking--icon mb-1">
            <div class="col-md p-0 text-center _relativeblock"
            v-for="(item, i) in otifList" :key="i">
              <img :id="`tooltip-${i}`" :style="getOtifColor(item.filterColor)"
              :src="item.imageOtif" alt="">
              <img class="_bullet" :style="getOtifColor(item.filterColor === 'red' ? 'blue'
              : item.filterColor)" src="@/assets/image/icon/bullet_line3.png" alt=""
              v-if="item.otifName !== 'BOOKED'">
              <b-tooltip :target="`tooltip-${i}`" id="tooltipTrackingStatus" placement="bottomright">
                <div class="tooltiptext text-left" v-if="item.content.length > 0">
                  <div class="row m-0" v-for="(otifContent, contentIndex) in item.content"
                  :key="contentIndex">
                    <p class="col-md-6 p-0">{{otifContent.title}}</p>
                    <p class="col-md p-0">: {{otifContent.data}} </p>
                  </div>
                </div>
              </b-tooltip>
            </div>
          </div>
          <div class="row m-0 msstatus__tracking--text">
            <div class="col-md p-0 text-center" v-for="(item, i) in otifList" :key="i">
              <p :class="getOtifTextColor(item.filterColor)">{{item.name}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md msstatus__additional mb-3"
      v-if="(this.detail.orderStat === 'REJECTED') ||
      (this.detail.orderStat === 'CANCELLED') || (this.detail.orderStat === 'COMPLETED_OTIF')">
        <div class="msstatus__additional--title mb-1"
        :class="this.detail.orderStat === 'COMPLETED_OTIF' ?
        'titleGreen' : 'titleRed'" >{{boxTitle}}</div>
        <div class="msstatus__additional--content">{{boxContent}}</div>
        <div class="msstatus__additional--content">{{boxReason}}</div>
        <div class="msstatus__additional--content mt-3" v-if="boxInfo">{{boxInfo}}</div>
      </div>
      <!-- table tracking log -->
      <div class="msstatus__tracking px-0">
        <p class="msstatus__tracking--title mb-2" style="padding-left: 14px">TRACKING LOG</p>
        <table class="table__tracking">
          <thead>
            <tr>
              <th :class="'global__bc_deepgreen'" scope="col" :width="item.width" v-for="(item, i) in trackingList.header" :key="i" :style="`width: ${item.title === 'Status' ? '60%' : '20%'}`">
                {{item.title}}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr  v-for="(item, i) in trackingList.body" :key="i" class="land">
              <td colspan="1">{{ item.datetime }}</td>
              <td colspan="1">{{ item.document_date }}</td>
              <td colspan="2">{{ item.status }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import mixin from '@/mixin/getters/shipment-details'
import * as consts from '@/constant/shipment-details'
import dateTime from '@/mixin/getters/date-time'
import moment from 'moment'

export default {
  name: 'ShipmentTrackingLand',
  data () {
    return {
      today: moment().format('YYYY-MM-DD'),
      format: 'DD/MM/YY',
      import: true, // true or false edit
      shipmentId: this.$route.params.id_shipment,
      orderNumber: this.$route.params.order_number,
      otifList: [],
      trackingList: {
        header: [{ title: 'Update Date', width: '30%' }, { title: 'Document Date', width: '30%' }, { title: 'Status', width: '40%' }],
        body: []
      },
      delayList: {
        header: ['Delay Date', 'Status', 'E. Delay Until', 'Delay Note', 'Attachment'],
        body: []
      },
      reasonRejected: '',
      reasonCancelled: '',
      boxTitle: '',
      boxContent: '',
      boxReason: '',
      boxInfo: '',
      idDelayLogSelected: ''
    }
  },
  mixins: [mixin, dateTime],
  computed: {
    ...mapGetters({
      // shipment
      detail: 'shipment/item',
      isLoadingDetail: 'shipment/isLoading',
      isError: 'shipment/error',
      // otif
      otif: 'shipment/otif',
      isLoadingOtif: 'shipment/otifIsLoading',
      isErrorOtif: 'shipment/errorOtif',
      // delay log
      getDelayLog: 'shipment/getDelayLog',
      isLoadingGetDelayLog: 'shipment/isLoadingGetDelayLog',
      isErrorGetDelayLog: 'shipment/isErrorGetDelayLog',

      isDownloading: 'shipment/isDownloading'
    })
  },
  async mounted () {
    this.createOtifList()
    await this.fetchShipmentDetail()
    await this.fetchShipmentOtifDetail()
  },
  methods: {
    resetData () {
      this.reasonRejected = ''
      this.reasonCancelled = ''
    },
    getOtifTextColor (type) {
      let nameClass = ''
      if (type === 'red') {
        nameClass = 'color_red'
      }
      if (type === 'green') {
        nameClass = 'color_green'
      }
      if (type === 'blue' || !type) {
        nameClass = 'color_blue'
      }
      if (type === 'grey') {
        nameClass = 'color_grey'
      }
      return nameClass
    },   
    createOtifList () {
      this.otifList = []
      const type = 'LAND'
      const booked = {
        name: 'Booked',
        otifName: consts.OTIF_BOOKED,
        imageOtif: this.getImageOtif(consts.OTIF_BOOKED, type, true)
      }
      const scheduled = {
        name: 'Scheduled',
        otifName: consts.OTIF_SCHEDULED,
        imageOtif: this.getImageOtif(consts.OTIF_SCHEDULED, type)
      }      
      // truck management system
      const started = {
        name: 'Started',
        otifName: consts.OTIF_STARTED,
        imageOtif: this.getImageOtif(consts.OTIF_STARTED, type)
      }
      const loading = {
        name: 'Loading',
        otifName: consts.OTIF_LOADING,
        imageOtif: this.getImageOtif(consts.OTIF_LOADING, type)
      }
      const inTransit = {
        name: 'InTransit',
        otifName: consts.OTIF_INTRANSIT,
        imageOtif: this.getImageOtif(consts.OTIF_INTRANSIT, type)
      }
      const unLoading = {
        name: 'UnLoading',
        otifName: consts.OTIF_UNLOADING,
        imageOtif: this.getImageOtif(consts.OTIF_UNLOADING, type)
      }
      const delivered = {
        name: 'Delivered',
        otifName: consts.OTIF_DELIVERED,
        imageOtif: this.getImageOtif(consts.OTIF_DELIVERED, type)
      }
      
      this.otifList.push(booked, scheduled, started, loading, inTransit, unLoading, delivered)
      
      this.otifList.forEach((item, i) => {
        if (item.name === 'Booked') {
          this.otifList[i] = Object.assign(item, { filterColor: '' }, { content: [] })
        } else {
          this.otifList[i] = Object.assign(item, { filterColor: 'grey' }, { content: [] })
        }
      })
    },
    async fetchShipmentDetail () {
      await this.$store.dispatch('shipment/FETCH_SHIPMENT_DETAIL', { shipmentId: this.shipmentId, orderNumber: this.orderNumber })
    },
    async fetchShipmentOtifDetail () {
      await this.$store.dispatch('shipment/FETCH_OTIF', { shipmentId: this.shipmentId, orderNumber: this.orderNumber })
    },
    getOtifContent (data) {
      const isCompleted = this.detail.orderStat === consts.OTIF_COMPLETED
      const isRejected = this.detail.orderStat === consts.OTIF_REJECTED
      const isCanceled = this.detail.orderStat === consts.OTIF_CANCELED

      if (isCompleted) {
        this.boxTitle = 'Shipment Completed'
        this.boxContent = 'Congratulation!! This shipment has been completed. You can see the status update record by clicking each status box below.'
        this.boxReason = ''
      }
      if (isRejected || isCanceled) {
        this.otifList[0].filterColor = 'red'
        this.boxTitle = isRejected ? 'Rejected Shipment' : 'Canceled Shipment'
        this.boxContent = `Unfortunately this shipment has been ${isRejected ? 'Rejected' : 'Canceled'} by the customer for reason as bellow : `
        this.boxReason = this.detail.orderStatNote
      }

      data.forEach((content) => {
        const isDelayed = content.delay && content.delay.length > 0
        this.otifList.forEach((list, i) => {
          if (list.otifName === consts.OTIF_BOOKED) {
            // eslint-disable-next-line no-nested-ternary
            this.otifList[i].filterColor = isCompleted ? 'green' : (isRejected || isCanceled) ? 'red' : ''
            this.otifList[i].imageOtif = this.getImageOtif(consts.OTIF_BOOKED, 'LAND', true)
          }
          if (content.status === list.name.toUpperCase()) {
            // eslint-disable-next-line no-nested-ternary
            this.otifList[i].filterColor = isCompleted ? 'green' : isDelayed ? 'red' : ''
            this.otifList[i].imageOtif = this.getImageOtif(list.otifName, 'LAND', true)
            this.otifList[i].content = []
            this.otifList[i].content.push(
              { title: 'Document Date', data: moment(content.document_date).format('DD/MM/YYYY') }
            )
          }
        })
      })
    },
    getOtif (data) {
      this.trackingList.body = [
        { datetime: this.getDateFormat1(this.detail.createdAt), document_date: this.getDateFormat1(this.detail.createdAt), status: 'Booked', details: [{label: '-', value: '-'}] }
      ]
      data.forEach((item) => {
        this.trackingList.body.push({
          datetime: moment(item.datetime).format('DD/MM/YYYY'),
          document_date: moment(item.document_date).format('DD/MM/YYYY'),
          status: item.status.slice(0, 1) + item.status.slice(1).toLowerCase()
        })
      })
    },
    getTime (date) {
      if (date) {
        const date1 = date.replace('T', ' ')
        const date2 = date1.replace(':00.000Z', '')
        return moment(date2).format('HH:mm')
      }
    }
  },
  watch: {
    otif (data) {
      if (data) {
        this.getOtif(data.statusHistory)
        this.getOtifContent(data.statusHistory)
      }
    },
    detail (data) {
      if (data) {
        this.reasonRejected = data.orderStat === 'REJECTED' ? data.orderStatNote : ''
        this.reasonCancelled = data.orderStat === 'CANCELLED' ? data.orderStatNote : ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/managementShipment/detail/ShipmentTrackingLand.vue